import Hero from './Hero'

const Banner = () => {
  return (
    <div className='banner sys_bg_white2 lg:px-20'>
      <Hero />
    </div>
  )
}

export default Banner